module.exports = __webpack_public_path__ + "img/commander.98d4dae0.jpg";